<template>
  <div class="mainContainer" v-loading="importLoading">
    <div class="nav">
      <el-form :model="searchForm" label-width="120px" :inline="true">
        <el-form-item label="委托商：">
          <el-input v-model="searchForm.customerName" size="mini" placeholder="请输入委托商" />
        </el-form-item>
        <el-form-item label="结算类型：">
          <el-select
            v-model="searchForm.settlementType"
            size="mini"
            filterable
            style="width: 100%"
            placeholder="请选择结算类型"
            value-key="id">
            <el-option
              v-for="item in settlementTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="港口/库房名称：">
          <el-input v-model="searchForm.name" size="mini" placeholder="请输入港口/库房名称" />
        </el-form-item>
        <el-form-item label="结算方式：">
          <el-select
            v-model="searchForm.contractType"
            size="mini"
            filterable
            style="width: 100%"
            placeholder="请选择结算方式"
            value-key="id">
            <el-option
              v-for="item in typeOption"
              :key="item.value"
              :label="item.label"
              :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="状态：">
          <el-select
            v-model="searchForm.status"
            size="mini"
            filterable
            style="width: 100%"
            placeholder="请选择状态"
            value-key="id">
            <el-option
              v-for="item in statusOption"
              :key="item.value"
              :label="item.label"
              :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="录入人员：">
          <el-input v-model="searchForm.createByName" size="mini" placeholder="请输入录入人员" />
        </el-form-item>
        <el-form-item>
          <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
          <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
          <el-button size="small" class="searchBtn" @click="btnClick('add')">新增</el-button>
          <el-button size="small" class="searchBtn" @click="btnClick('batchEnable')"
            >启用</el-button
          >
          <el-button size="small" type="danger" @click="onClcikDeletes">批量删除</el-button>
          <el-button size="small" class="resetBtn" @click="onClickStops">批量停用</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-row>
      <el-col :span="24" style="text-align: end" class="exportButton">
        <div style="display: flex; justify-content: flex-end">
          <span @click="download">模板下载</span>
          <batch-import
            :uploadUrl="uploadUrl"
            @importSuccess="searchBtn"
            @triggerLoading="importLoading = !importLoading" />
          <span class="mr0" @click="exportData">导出数据</span>
        </div>
      </el-col>
    </el-row>
    <div class="content">
      <el-table
        ref="registerTable"
        row-key="id"
        v-loading="tableLoading"
        :data="tableData"
        style="width: 100%"
        border
        :header-cell-style="headerCellStyle"
        @selection-change="selectionChange"
        :row-style="rowStyle">
        <el-table-column type="selection" align="center" min-width="50" />
        <el-table-column label="合同编号" prop="contractCode" align="center" width="180" />
        <el-table-column label="合同名称" prop="contractName" align="center" width="220" />
        <el-table-column label="委托商" prop="customerName" align="center" width="240" />
        <el-table-column
          label="结算类型"
          prop="settlementType"
          align="center"
          :formatter="settlementTypeFormat" />
        <el-table-column label="港口/库房名称" prop="name" align="center" width="160" />
        <el-table-column
          label="品牌"
          prop="brands"
          align="center"
          width="180"
          show-overflow-tooltip />
        <el-table-column label="作业类型" prop="taskType" align="center" width="160" />
        <el-table-column
          label="价格有效期"
          prop="date"
          align="center"
          width="200"
          show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.startDate | validityDady }}--{{ scope.row.endDate | validityDady }}
          </template>
        </el-table-column>
        <el-table-column label="税率%" prop="taxRate" align="center" />
        <el-table-column label="合同单价" prop="contractPrice" align="center" />
        <el-table-column label="预结算单价" prop="preparePrice" align="center" width="140" />
        <el-table-column label="预估单价" prop="estimatePrice" align="center" />
        <el-table-column
          prop="createTime"
          label="创建时间"
          show-overflow-tooltip
          width="150"
          align="center">
          <template slot-scope="scope">{{ scope.row.createTime | getCreatTime }}</template>
        </el-table-column>
        <el-table-column
          prop="createByName"
          label="录入人员"
          show-overflow-tooltip
          width="150"
          align="center" />
        <el-table-column label="状态" prop="status" align="center" :formatter="statusFormat" />
        <el-table-column label="操作" width="450" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" class="searchBtn" @click="btnClick('info', scope.row)"
              >详情
            </el-button>
            <el-button
              size="mini"
              v-if="scope.row.status === 0"
              class="yellow-bg"
              @click="btnClick('edit', scope.row)"
              >修改
            </el-button>
            <!--            <el-button size="mini" class="yellow-bg" @click="recordBtn(scope.row)">-->
            <!--              补录合同-->
            <!--            </el-button>-->
            <el-button size="mini" class="resetBtn" @click="btnClick('delete', scope.row)"
              >删除
            </el-button>
            <el-button
              size="mini"
              v-if="scope.row.status === 0"
              class="searchBtn"
              @click="btnClick('enable', scope.row)"
              >启用
            </el-button>
            <el-button
              size="mini"
              v-if="scope.row.status === 1"
              type="danger"
              @click="btnClick('disabled', scope.row)"
              >停用
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="paginationContainer">
        <el-pagination
          background
          :page-sizes="[10, 20, 30, 40]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="contractSizeChange"
          @current-change="contractCurrentChange"
          :current-page.sync="searchForm.page"
          :page-size="searchForm.rows" />
      </div>
    </div>

    <!-- 新增/编辑 -->
    <harbor-warehouse-income-price-setting-form
      ref="harborWarehouseIncomePriceSettingFormRef"
      @searchBtn="searchBtn" />
    <!-- 详情 -->
    <harbor-warehouse-income-price-setting-info ref="harborWarehouseIncomePriceSettingInfoRef" />
    <!-- 完善价格 -->
    <perfect-price ref="perfectPriceRef" @searchBtn="searchBtn" />
    <!-- 补录合同 -->
    <add-contract ref="addContractRef" />
  </div>
</template>

<script>
  import HarborWarehouseIncomePriceSettingForm from '@/views/financial/price/harbor-warehouse-income-price-setting/components/form';
  import HarborWarehouseIncomePriceSettingInfo from './components/info';
  import PerfectPrice from '@/views/financial/price/harbor-warehouse-income-price-setting/components/perfect-price';
  import BatchImport from '@/components/batchImport';
  import { formatDateTime, formatTime, getSessionStore } from '@/config/mUtils';
  import { baseUrl } from '@/config/env';
  import {
    portWarehouseConsignorPriceSettingDelete,
    portWarehouseConsignorPriceSettingEnableOrDisabled,
    portWarehouseConsignorPriceSettingList,
  } from '@/service/warehouse';
  import AddContract from '@/views/financial/price/harbor-warehouse-income-price-setting/components/addContract.vue';

  export default {
    name: 'harborWarehouseIncomePriceSetting',
    components: {
      AddContract,
      HarborWarehouseIncomePriceSettingForm,
      HarborWarehouseIncomePriceSettingInfo,
      PerfectPrice,
      BatchImport,
    },
    data() {
      return {
        importLoading: false,
        pickerOptions: {
          shortcuts: [
            {
              text: '最近一周',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                picker.$emit('pick', [start, end]);
              },
            },
            {
              text: '最近一个月',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                picker.$emit('pick', [start, end]);
              },
            },
            {
              text: '最近三个月',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                picker.$emit('pick', [start, end]);
              },
            },
          ],
        },
        searchForm: {
          status: '',
          page: 1,
          rows: 10,
          customerName: '',
          settlementType: '',
          name: '',
          contractType: '',
          createByName: ''
        },
        defaultSearchForm: {},
        tableLoading: false,
        tableData: [],
        headerCellStyle: {
          color: '#3B3B3B',
          'font-size': '13px',
          height: '48px',
          background: '#E8E8E8',
        },
        total: 0,
        settlementTypeOptions: [
          {
            value: 1,
            label: '港口',
          },
          {
            value: 0,
            label: '库房',
          },
        ],
        typeOption: [
          {
            value: 0,
            label: '合同价',
          },
          {
            value: 1,
            label: '预结算价',
          },
          {
            value: 2,
            label: '只有预估算价',
          },
        ],
        statusOption: [
          {
            value: '',
            label: '全部',
          },
          {
            value: '0',
            label: '待生效',
          },
          {
            value: '1',
            label: '生效中',
          },
          {
            value: '2',
            label: '已失效',
          },
        ],
        selectedData: [],
        uploadUrl: '/price/consignor/portAndWarehouse/batchLinePrice',
      };
    },
    mounted() {
      this.defaultSearchForm = JSON.parse(JSON.stringify(this.searchForm));
      // this.searchBtn();
    },
    filters: {
      //有效期
      validityDady(val) {
        return formatTime(val, 'yyyy-mm-dd hh:ii:ss');
      },
      getCreatTime(val) {
        if (val) {
          return formatDateTime(val, 'yyyy-mm-dd hh:ii:ss');
        } else {
          return '';
        }
      },
    },
    methods: {
      // 结算类型
      settlementTypeFormat(row, column, cellValue) {
        switch (cellValue) {
          case 0:
            return '库房';
          case 1:
            return '港口';
        }
      },
      // 状态格式化
      statusFormat(row, column, cellValue) {
        switch (cellValue) {
          case 0:
            return '待生效';
          case 1:
            return '生效中';
          case 2:
            return '已失效';
        }
      },
      // 查询
      searchBtn() {
        this.searchForm.page = 1;
        this.getTableData();
      },
      // 重置
      resetBtn() {
        this.searchForm = JSON.parse(JSON.stringify(this.defaultSearchForm));
      },
      // 获取表格数据
      async getTableData() {
        this.tableLoading = true;
        const { status, message, data } = await portWarehouseConsignorPriceSettingList(
          this.searchForm,
        );
        this.tableLoading = false;
        if (status !== 0) return this.$message.warning(message);
        this.tableData = data.records;
        this.total = data.total;
      },
      /**
       * 按钮点击
       * @param str 当前按钮标识
       * @param row 当前选中数据
       */
      btnClick(str, row) {
        switch (str) {
          case 'add':
            this.$refs.harborWarehouseIncomePriceSettingFormRef.dialogOpen('新增');
            break;
          case 'edit':
            this.$refs.harborWarehouseIncomePriceSettingFormRef.dialogOpen('修改', row);
            break;
          case 'info':
            this.$refs.harborWarehouseIncomePriceSettingInfoRef.dialogOpen(row.id);
            break;
          case 'perfectPrice':
            this.$refs.perfectPriceRef.dialogOpen(row);
            break;
          case 'batchEnable':
            if (this.selectedData.length === 0)
              return this.$message.warning('请选择数据后批量提交');
            const ids = this.selectedData.map(item => item.id).join(',');
            this.enableOrDisabled(ids, str);
            break;
          case 'enable':
            this.enableOrDisabled(row.id, str);
            break;
          case 'disabled':
            this.enableOrDisabled(row.id, str);
            break;
          case 'delete':
            this.deleteData(row.id);
            break;
        }
      },
      // 补录合同
      recordBtn(row) {
        this.$refs.addContractRef.dialogOpen(row);
      },
      /**
       * 删除
       * @param id 当前选中数据 id
       */
      deleteData(id) {
        this.$confirm('确认删除当前数据？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(async () => {
          const { status, message } = await portWarehouseConsignorPriceSettingDelete(id);
          if (status !== 0) return this.$message.warning(message);
          this.$message.success(message);
          await this.getTableData();
        });
      },
      // 批量删除
      onClcikDeletes() {
        // console.log(this.selectedData);
        if (this.selectedData.length > 0) {
          this.$confirm('确认删除当前选中数据？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }).then(async () => {
            this.tableLoading = true;
            // let ids = '';
            // this.selectedData.forEach(rowData => {
            //   ids = ids + rowData['id'] + ',';
            // });
            // ids = ids.substring(0, ids.lastIndexOf(','));
            const ids = this.selectedData.map(item => item.id).join(',');
            const { status, message } = await portWarehouseConsignorPriceSettingDelete(ids);
            if (status !== 0) {
              this.$message.warning(message);
              this.tableLoading = false;
              return;
            }
            this.$message.success(message);
            this.$refs.registerTable.clearSelection();
            this.selectedData = [];
            await this.getTableData();
          });
        } else {
          this.$message({
            message: '请先选择数据！',
            type: 'warning',
          });
        }
      },
      /**
       * 批量启用/启用/停用
       * @param ids 当前选中数据 id
       * @param str 区分启用停用
       */
      enableOrDisabled(ids, str) {
        this.$confirm(`确认${str === 'disabled' ? '停用' : '启用'}当前选中数据？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(async () => {
          const { status, message } = await portWarehouseConsignorPriceSettingEnableOrDisabled({
            ids,
          });
          if (status !== 0) return this.$message.warning(message);
          this.$message.success(message);
          this.clearCheckTableData();
        });
      },
      // 批量停用
      onClickStops() {
        // console.log(this.selectedData);
        if (this.selectedData.length > 0) {
          this.$confirm(`确认停用当前选中数据？`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }).then(async () => {
            this.tableLoading = true;
            const ids = this.selectedData.map(item => item.id).join(',');
            const { status, message } = await portWarehouseConsignorPriceSettingEnableOrDisabled({
              ids,
            });
            if (status !== 0) {
              this.$message.warning(message);
              this.tableLoading = false;
              return;
            }
            this.$message.success(message);
            this.$refs.registerTable.clearSelection();
            this.selectedData = [];
            this.clearCheckTableData();
          });
        } else {
          this.$message({
            message: '请先选择数据！',
            type: 'warning',
          });
        }
      },
      clearCheckTableData() {
        this.$refs.registerTable.clearSelection();
        this.selectedData = [];
        this.getTableData();
      },
      // 导出数据
      exportData() {
        // let token = getSessionStore('token');
        // window.location.href = `${baseUrl}/platform/price/consignor/portAndWarehouse/priceExport?access_token=${token}&customerName=${
        //   this.searchForm.customerName || ''
        // }&settlementType=${this.searchForm.settlementType || ''}&name=${
        //   this.searchForm.name || ''
        // }&contractType=${this.searchForm.contractType}`;
        window.exportExcelGet('/platform/price/consignor/portAndWarehouse/priceExport', `
        customerName=${
          this.searchForm.customerName || ''
        }&settlementType=${this.searchForm.settlementType || ''}&name=${
          this.searchForm.name || ''
        }&contractType=${this.searchForm.contractType}`)
      },
      selectionChange(selectionRow) {
        this.selectedData = selectionRow;
      },
      rowStyle({ row }) {
        return this.selectedData.includes(row) ? { background: 'rgb(197 226 255)' } : {};
      },
      contractSizeChange(row) {
        this.searchForm.rows = row;
        this.searchForm.page = 1;
        this.getTableData();
      },
      contractCurrentChange(page) {
        this.searchForm.page = page;
        this.getTableData();
      },
      download() {
        window.location.href = '/file/港口库房价格设置（收入）模板.xlsx';
      },
    },
  };
</script>

<style lang="scss" scoped>
  .mainContainer {
    width: 100%;
    padding: 20px 15px 0 15px;
    //background-color: #fff;

    .nav {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      &Btn {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
      }
    }

    .content {
      .paginationContainer {
        margin-right: auto;
        display: flex;
        align-items: center;
        margin-top: 10px;

        span {
          font-size: 13px;
        }
      }
    }
  }
  ::v-deep {
    .transportTitle {
      z-index: 99;
    }

    .el-table__body tr.current-row > td {
      background-color: #409eff;
      color: #fff !important;
    }

    .cell .el-form-item {
      padding: 0 2px;
    }

    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #335483;
      text-align: center;
    }

    .el-dialog__headerbtn {
      top: 0px;
      height: 42px;
      line-height: 42px;
      right: 10px;
      font-size: 20px;

      .el-dialog__close {
        color: #fff;
        font-size: 25px;
      }
    }

    .el-dialog__title {
      color: #fff;
      font-weight: 700;
      font-size: 16px;
      line-height: 24px;
    }

    .el-dialog__body {
      padding: 20px !important;
      max-height: 60vh;
      overflow-y: auto;
    }
  }
</style>
